const BASE_INTENT_OPTIONS = [
  'Help me shoot lower scores',
  'Fix a specific problem in my golf game',
  'Help my junior golfer improve',
  'Connect me with other golfers',
]

const INTRODUCTION_OPTIONS = [
  'Introduce me to golf',
  'Introduce my child to golf',
  'Introduce my family to golf',
]

const MAX_UINT32 = 4294967296

const hashString = (str = '') => {
  let hash = 0
  for (let i = 0; i < str.length; i += 1) {
    hash = (Math.imul(hash, 31) + str.charCodeAt(i)) % MAX_UINT32
    if (hash < 0) hash += MAX_UINT32
  }
  return hash
}

const rotate = (arr, offset) => {
  if (!arr.length) return arr
  const o = offset % arr.length
  if (o === 0) return arr
  return arr.slice(o).concat(arr.slice(0, o))
}

export const getLeadIntentOptions = (seed) => {
  const h = hashString(seed)
  const rotatedBase = rotate(BASE_INTENT_OPTIONS, h)
  const insertIndex = h % (rotatedBase.length + 1)

  const options = [...rotatedBase]
  options.splice(insertIndex, 0, ...INTRODUCTION_OPTIONS)
  return options
}
